export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // --- "See Why Lelly Exists" — inline video playback --------------------
    const buildVideoEmbed = (url) => {
      if (!url) return '';
      url = url.trim();

      const yt = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
      );
      if (yt) {
        return (
          '<iframe src="https://www.youtube.com/embed/' + yt[1] +
          '?autoplay=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>'
        );
      }

      const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) {
        return (
          '<iframe src="https://player.vimeo.com/video/' + vm[1] +
          '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'
        );
      }

      if (/\.(mp4|webm|ogg|ogv|mov)(\?.*)?$/i.test(url)) {
        return '<video src="' + url + '" controls autoplay playsinline></video>';
      }

      // Generic fallback (e.g. a self-hosted embed URL)
      return '<iframe src="' + url + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    };

    $(document).on('click', '.video-frame__play', function (e) {
      e.preventDefault();

      const $frame = $(this).closest('.video-frame');
      if ($frame.hasClass('is-playing')) return;

      const embed = buildVideoEmbed($frame.attr('data-video-url') || $(this).attr('href'));
      if (!embed) return;

      $frame.addClass('is-playing').append(embed); // poster stays for sizing
      $(this).hide();                              // remove the Play button
    });

    // --- Mobile footer menu (hamburger) toggle -----------------------------
    $(document).on('click', '.footer-menu-toggle', function () {
      const expanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', String(!expanded));
      $(this).closest('.content-info').toggleClass('footer--menu-open');
    });

    // --- Custom file-upload buttons (Optional Video Introduction) ----------
    const lellyUploaders = {
      'upload-video': { icon: '/wp-content/uploads/2026/07/Video-Upload.png', text: 'Upload Video' },
      'upload-resume': { icon: '/wp-content/uploads/2026/07/Upload-icon.png', text: 'Upload Resume/CV' },
    };

    Object.keys(lellyUploaders).forEach(function (cls) {
      const cfg = lellyUploaders[cls];

      $('.gfield.' + cls).each(function () {
        const $field = $(this);
        const $input = $field.find('input[type="file"]').first();
        if (!$input.length || $field.find('.lelly-upload').length) return;

        const id = $input.attr('id');

        const $ui = $(
          '<div class="lelly-upload">' +
          '<img class="lelly-upload__icon" src="' + cfg.icon + '" alt="">' +
          '<label class="lelly-upload__btn" for="' + id + '">' + cfg.text + '</label>' +
          '<span class="lelly-upload__file"></span>' +
          '</div>'
        );

        $input.addClass('lelly-upload__input').after($ui);

        $input.on('change', function () {
          const name = this.files && this.files.length ? this.files[0].name : '';
          $ui.find('.lelly-upload__file').text(name);
        });
      });
    });

    // --- Custom E-Signature (Type / Draw / Upload) ------------------------
    $('.gfield.lelly-signature-field').each(function () {
      const $field = $(this);
      const $store = $field.find('textarea, input[type="text"]').first();
      if (!$store.length || $field.find('.lelly-esign').length) return;

      const d = new Date();
      const dateStr =
        String(d.getMonth() + 1).padStart(2, '0') + '/' +
        String(d.getDate()).padStart(2, '0') + '/' + d.getFullYear();

      const $ui = $(
        '<div class="lelly-esign">' +
        '<div class="lelly-esign__topbar"><span class="lelly-esign__date">' + dateStr + '</span></div>' +
        '<div class="lelly-esign__box">' +
        '<div class="lelly-esign__head">' +
        '<div class="lelly-esign__tabs">' +
        '<button type="button" class="lelly-esign__tab is-active" data-mode="type">Type</button>' +
        '<button type="button" class="lelly-esign__tab" data-mode="draw">Draw</button>' +
        '<button type="button" class="lelly-esign__tab" data-mode="upload">Upload</button>' +
        '</div>' +
        '<button type="button" class="lelly-esign__clear">CLEAR</button>' +
        '</div>' +
        '<div class="lelly-esign__body">' +
        '<div class="lelly-esign__pane" data-pane="type">' +
        '<input type="text" class="lelly-esign__type-input" placeholder="Type your full name">' +
        '</div>' +
        '<div class="lelly-esign__pane" data-pane="draw" hidden>' +
        '<canvas class="lelly-esign__canvas"></canvas>' +
        '</div>' +
        '<div class="lelly-esign__pane" data-pane="upload" hidden>' +
        '<label class="lelly-esign__uploadbtn">Choose image' +
        '<input type="file" accept="image/*" class="lelly-esign__file">' +
        '</label>' +
        '<img class="lelly-esign__preview" alt="">' +
        '</div>' +
        '<span class="lelly-esign__line"></span>' +
        '</div>' +
        '</div>' +
        '</div>'
      );

      $store.addClass('lelly-esign__store').after($ui);
      const setVal = (v) => { $store.val(v).trigger('change'); };

      const $tabs = $ui.find('.lelly-esign__tab');
      const $panes = $ui.find('.lelly-esign__pane');
      let mode = 'type';

      const canvas = $ui.find('.lelly-esign__canvas')[0];
      const ctx = canvas.getContext('2d');
      let drawing = false, hasDrawn = false, sized = false;

      const sizeCanvas = () => {
        const rect = canvas.getBoundingClientRect();
        const ratio = window.devicePixelRatio || 1;
        canvas.width = rect.width * ratio;
        canvas.height = rect.height * ratio;
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.strokeStyle = '#222';
        sized = true;
      };
      const point = (e) => {
        const r = canvas.getBoundingClientRect();
        const p = e.touches ? e.touches[0] : e;
        return { x: p.clientX - r.left, y: p.clientY - r.top };
      };
      const start = (e) => { drawing = true; const p = point(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); e.preventDefault(); };
      const move = (e) => { if (!drawing) return; const p = point(e); ctx.lineTo(p.x, p.y); ctx.stroke(); hasDrawn = true; e.preventDefault(); };
      const stop = () => { if (!drawing) return; drawing = false; if (hasDrawn) setVal(canvas.toDataURL('image/png')); };

      canvas.addEventListener('mousedown', start);
      canvas.addEventListener('mousemove', move);
      window.addEventListener('mouseup', stop);
      canvas.addEventListener('touchstart', start, { passive: false });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', stop);

      $tabs.on('click', function () {
        mode = $(this).data('mode');
        $tabs.removeClass('is-active');
        $(this).addClass('is-active');
        $panes.prop('hidden', true).filter('[data-pane="' + mode + '"]').prop('hidden', false);
        if (mode === 'draw' && !sized) sizeCanvas();
      });

      $ui.find('.lelly-esign__type-input').on('input', function () {
        setVal($(this).val());
      });

      $ui.find('.lelly-esign__file').on('change', function () {
        const f = this.files && this.files[0];
        if (!f) return;
        const reader = new FileReader();
        reader.onload = (e) => {
          $ui.find('.lelly-esign__preview').attr('src', e.target.result).css('display', 'block');
          setVal(e.target.result);
        };
        reader.readAsDataURL(f);
      });

      $ui.find('.lelly-esign__clear').on('click', function () {
        if (mode === 'type') {
          $ui.find('.lelly-esign__type-input').val('');
        } else if (mode === 'draw') {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          hasDrawn = false;
        } else {
          $ui.find('.lelly-esign__file').val('');
          $ui.find('.lelly-esign__preview').attr('src', '').css('display', 'none');
        }
        setVal('');
      });
    });

    // --- Careers: Open Roles filter + pagination ---------------------------
    $('.open-roles').each(function () {
      const $section = $(this);
      const $grid = $section.find('.open-roles__grid');
      const $items = $grid.find('.role-item');
      const $tabs = $section.find('.role-tab');
      const $pager = $section.find('.open-roles__pagination');
      const $select = $section.find('.open-roles__select');
      const perPage = parseInt($grid.data('per-page'), 10) || 6;

      let filter = 'all';   // show everything on first load (matches the XD)
      let page = 1;

      const filtered = () => $items.filter(function () {
        if (filter === 'all') return true;
        return ((' ' + ($(this).attr('data-category') || '') + ' ')
          .indexOf(' ' + filter + ' ') > -1);
      });

      const render = () => {
        const $f = filtered();
        const pages = Math.max(1, Math.ceil($f.length / perPage));
        if (page > pages) page = pages;

        $items.hide();
        $f.each(function (i) {
          if (i >= (page - 1) * perPage && i < page * perPage) $(this).show();
        });

        $pager.empty();
        if (pages <= 1) return;

        const btn = (label, target, disabled, active) => {
          const $b = $('<button type="button" class="role-page"></button>').html(label);
          if (active) $b.addClass('is-active');
          if (disabled) $b.prop('disabled', true);
          else $b.on('click', () => { page = target; render(); });
          $pager.append($b);
        };

        btn('&lsaquo;', page - 1, page === 1, false);
        for (let p = 1; p <= pages; p++) btn(p, p, false, p === page);
        btn('&rsaquo;', page + 1, page === pages, false);
      };

      $tabs.on('click', function () {
        $tabs.removeClass('is-active');
        $(this).addClass('is-active');
        filter = $(this).attr('data-filter');
        $select.val(filter);
        page = 1;
        render();
      });

      // Tablet/mobile dropdown -> same filtering, kept in sync with the tabs
      $select.on('change', function () {
        filter = $(this).val();
        $tabs.removeClass('is-active').filter('[data-filter="' + filter + '"]').addClass('is-active');
        page = 1;
        render();
      });

      render();
    });

    // --- Success Stories: "Meet the People" slider -------------------------
    const $people = $('.people-slider');

    if ($people.length && typeof $.fn.slick === 'function') {
      $people.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 450,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnHover: true,
        pauseOnFocus: false,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
      });
    }


    // --- Home features: 1-up slider with dots on mobile only ---------------
    const $featuresGrid = $('.features-grid');
    if ($featuresGrid.length && typeof $.fn.slick === 'function') {
      const featuresMQ = window.matchMedia('(max-width: 767px)');

      const syncFeatures = () => {
        const on = $featuresGrid.hasClass('slick-initialized');
        if (featuresMQ.matches && !on) {
          $featuresGrid.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 7000,
          });
        } else if (!featuresMQ.matches && on) {
          $featuresGrid.slick('unslick');
        }
      };

      syncFeatures();
      if (featuresMQ.addEventListener) featuresMQ.addEventListener('change', syncFeatures);
      else $(window).on('resize', syncFeatures);
    }


    // --- Testimonials carousel (Slick) -------------------------------------
    // Guarded so it only runs where the slider markup exists.
    const $slider = $('.testimonials-slider');

    if ($slider.length && typeof $.fn.slick === 'function') {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding: '0',
        arrows: true,
        dots: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnHover: true,
        pauseOnFocus: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><span>‹</span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span>›</span></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 1, centerMode: false },
          },
          {
            breakpoint: 576,
            settings: { slidesToShow: 1, centerMode: false },
          },
        ],
      });
    }

    // --- Our Story: Why Lelly? photo carousel ------------------------------
    const $whySlider = $('.why-photos-slider');
    if ($whySlider.length && typeof $.fn.slick === 'function') {
      $whySlider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        speed: 600,
        cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        pauseOnFocus: false,
        prevArrow: '<button type="button" class="slick-prev why-slick-prev" aria-label="Previous"></button>',
        nextArrow: '<button type="button" class="slick-next why-slick-next" aria-label="Next"></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 2 },
          },
          {
            breakpoint: 576,
            settings: { slidesToShow: 1 },
          },
        ],
      });
    }

    function equalizeWhyBlockImageHeight() {
      $('.why-block').each(function () {
        if (window.innerWidth <= 991) return;

        const textHeight = $(this)
          .find('.why-block__text')
          .closest('[class*="col-"]')
          .outerHeight(true);

        $(this)
          .find('.why-block__img')
          .height(textHeight);
      });
    }

    $(window).on('load resize', equalizeWhyBlockImageHeight);
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js